import {SiteEntity} from "./siteEntity.model";

export interface ViewSettingsModel extends SiteEntity {
  name?: string;
  description?: boolean;
  pageName?: string
  holderIds?: string[];
  holderType?: ViewSettingsHolderType;
  settings?: any;
  settingsType?: ViewSettingsType;
  isDefault?: boolean;
}

export enum ViewSettingsHolderType  {
  Site = "Site",
  User = "User"
}

export enum ViewSettingsType  {
  Form = "Form",
  ViewTable = "ViewTable",
  DraftPanels = "DraftPanels",
  Filter = "Filter",
  HomePage = "HomePage",
  GeneralSettings = "GeneralSettings",
  Dashboard = "Dashboard"
}


